import './OverviewStats.scoped.scss'
import store from 'CampaignStats/store'
import useAct from 'CampaignStats/useAct'

import { Provider } from 'react-redux'
import PhoneOverviewStats from './Phone/PhoneOverviewStats'

import OrganisationPickerButton from 'Shared/components/OrganisationPicker/OrganisationPickerButton'
import TextOverviewStats from './Text/TextOverviewStats'


export default function OverviewStats() {
  return (
    <div>
      <Provider store={store}>
        <OverviewStatsContent />
      </Provider>
    </div>
  )
}

function OverviewStatsContent() {
  const act = useAct()

  const { campaignId } = useSel(s => s.local)

  const campaign = useSel(s => s.campaign)

  useEffect(() => {
    if (!campaignId) return

    act.campaignStats.loadMe()
    act.campaign.load(campaignId)
    const interval = setInterval(act.campaignStats.reloadStats, 120 * 1000)
    return () => {
      clearInterval(interval)
    }
  }, [campaignId])

  if (campaign.campaignType === 'phone') {
    return <CampaignLaunchingLoadingWrapper>
      <OrganisationSelector />
      <PhoneOverviewStats />
    </CampaignLaunchingLoadingWrapper>
  }
  if (campaign.campaignType === 'sms_conversations') {
    return <CampaignLaunchingLoadingWrapper>
      <OrganisationSelector />
      <TextOverviewStats />
    </CampaignLaunchingLoadingWrapper>
  }
  return <></>
}

function CampaignLaunchingLoadingWrapper(props) {
  const { campaignId, loading } = useSel(s => s.local)
  const [status, setStatus] = useState('')
  const campaignStats = useSel(s => s.local.campaignStats || {})

  useEffect(() => {
    let intervalId

    const checkStatus = async () => {
      const response = await fetch(`/api/campaigns/${campaignId}/status`)
      const data = await response.json()
      setStatus(data.status)

      if (data.status !== 'launching') {
        clearInterval(intervalId)
      }
    }

    if (status === 'launching' || status === '') {
      checkStatus();
      intervalId = setInterval(checkStatus, 1000)
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId)
      }
    };
  }, [campaignId])

  if (status == 'launching') {
    return (<div className='box'>
      <p className='no-margin-top no-margin-bottom'>Your campaign is launching now! Once it's ready, you'll be able to see information about how it's going.</p>
    </div>)
  }

  if (!campaignStats || loading) {
    return (<div className='box'>
      <p className='no-margin-top no-margin-bottom'>Your campaign is loading now! Once it's ready, you'll be able to see information about how it's going.</p>
    </div>)
  }

  return <>{props.children}</>
}

function OrganisationSelector() {
  const act = useAct()
  const { chosenOrganisationId, chosenOrganisationName } = useSel(s => s.local)

  const pickOrganisation = (id, name) => {
    act.local.upsert({ chosenOrganisationId: id, chosenOrganisationName: name })
    act.campaignStats.setOrganisationId(id)
  }

  return <>
    <div className="header">
      {chosenOrganisationId && <div className="actions">
        <label>Organisation: {chosenOrganisationName}</label>
        <OrganisationPickerButton title="Change" onPick={(id, name) => pickOrganisation(id, name)} />
      </div>}
    </div>
  </>
}

